import { keyframes, style } from '@vanilla-extract/css';

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

const shimmer = keyframes({
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
});

export const container = style({
  width: '100%',
  boxSizing: 'border-box',
  flex: 'none',
});

export const playerWrapper = style({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '12px',
  borderRadius: '8px',
  width: '100%',
  boxSizing: 'border-box',
  height: 'fit-content',
});

export const thumbnail = style({
  width: '64px',
  height: '64px',
  borderRadius: '6px',
  objectFit: 'cover',
  flexShrink: 0,
});

export const playerContent = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
});

export const title = style({
  fontSize: '14px',
  fontWeight: 'bold',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const controlsRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

export const controlButton = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px',
  borderRadius: '50%',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  transition: 'background-color 150ms',
  ':hover': {
    backgroundColor: 'rgba(128, 128, 128, 0.15)',
  },
  ':disabled': {
    opacity: 0.4,
    cursor: 'default',
  },
});

export const skipButton = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  padding: '2px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  transition: 'opacity 150ms',
  ':hover': {
    opacity: 0.7,
  },
  ':disabled': {
    opacity: 0.4,
    cursor: 'default',
  },
});

export const skipLabel = style({
  position: 'absolute',
  fontSize: '8px',
  fontWeight: 'bold',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
});

export const progressRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
});

export const timeLabel = style({
  fontSize: '12px',
  textAlign: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  opacity: 0.6,
});

export const progressBar = style({
  flex: 1,
  height: '8px',
  borderRadius: '9999px',
  overflow: 'hidden',
  cursor: 'pointer',
  backgroundColor: 'rgba(128, 128, 128, 0.3)',
});

export const progressFill = style({
  height: '100%',
  borderRadius: '9999px',
  transition: 'width 100ms linear',
});

export const waveformWrapper = style({
  flex: 1,
  minWidth: 0,
  position: 'relative',
});

export const waveformContainer = style({
  width: '100%',
});

export const spinnerIcon = style({
  animation: `${spin} 1s linear infinite`,
});

export const playButtonWrapper = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const spinnerOverlay = style({
  position: 'absolute',
  inset: 0,
  borderRadius: '50%',
  border: '2px solid transparent',
  borderTopColor: 'currentColor',
  animation: `${spin} 0.8s linear infinite`,
  pointerEvents: 'none',
  opacity: 0.7,
});

export const waveformLoading = style({
  position: 'absolute',
  inset: 0,
  borderRadius: '4px',
  background:
    'linear-gradient(90deg, rgba(128,128,128,0.08) 25%, rgba(128,128,128,0.18) 50%, rgba(128,128,128,0.08) 75%)',
  backgroundSize: '200% 100%',
  animation: `${shimmer} 1.5s ease-in-out infinite`,
});
